import BaseApi from '../base/base'
import Thread from '../../models/thread'
import ThreadForm from '../../forms/thread'

export default class ThreadApi extends BaseApi {
  constructor() {
    super()
    this.path = '/chat_threads'
  }

  async index(params: {targetableId: string, targetableType: string}) {
    this.path = '/chat_threads'
    const response = await this.getRequest(params)
    return response.data.map((element) => {
      return new Thread(element)
    })
  }

  async create(params: ThreadForm) {
    this.path = '/chat_threads'
    const response = await this.postRequest(params)
    return new Thread(response.data)
  }

  async update(id: number, params: { name: string }) {
    this.path = `/chat_threads/${id}`
    const response = await this.patchRequest(params)
    return new Thread(response.data)
  }

  async delete(id: number) {
    this.path = `/chat_threads/${id}`
    const response = await this.deleteRequest()
    return new Thread(response.data)
  }
}
